import React from 'react';
import { FieldError } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import * as yup from 'yup';

import { CreditCardType, SupportedCreditCardTypes } from '../../constants/forms';
import { cardValidator } from '../../constants/regularExpressions';

export type ConvertErrorMessageParams = {
  error?: FieldError | string | null;
  messages: Record<string, { defaultMessage: string; id: string }>;
  values?: Record<string, string | number>;
};

const convertErrorMessage = ({
  messages,
  error,
  values,
}: ConvertErrorMessageParams) => {
  if (typeof error === 'string') {
    return error;
  }
  if (!error || !error.message) {
    return null;
  }

  if (messages[error.message]) {
    return <FormattedMessage {...messages[error.message]} values={values} />;
  }

  return error.message;
};

function setCardIsNotSupportedError(this: yup.TestContext<Record<string, any>>, cardNumber: string) {
  const { path, createError } = this;
  let cardType: CreditCardType | null = null;
  const cardNumberWithoutSpaces = cardNumber.replaceAll(' ', '');

  if (!cardNumberWithoutSpaces) {
    return true;
  }

  for (const [key, value] of Object.entries(cardValidator)) {
    if (value.test(cardNumberWithoutSpaces)) {
      cardType = key as CreditCardType;
      break;
    }
  }

  const isCardSupported =
    cardType
    && Object.values(SupportedCreditCardTypes).includes(
      (cardType as unknown) as SupportedCreditCardTypes,
    );

  if (!isCardSupported) {
    return createError({ path, message: 'cardNumberNotSupportedError' });
  }

  return true;
}

export const errorUtils = {
  convertErrorMessage,
  setCardIsNotSupportedError,
};
